import React from 'react'
import Modal from '../Modal/Modal'
import Button from '../Button/Button'
import './ConfirmationModal.css'

/**
 * ConfirmationModal komponent til bekræftelsesdialoger
 * @param {boolean} isOpen - Om modalen er åben eller lukket
 * @param {function} onClose - Funktion der kaldes når modalen lukkes
 * @param {function} onConfirm - Funktion der kaldes når brugeren bekræfter
 * @param {string} title - Titel der vises i modal header
 * @param {string} message - Besked der vises i modal body
 * @param {string} confirmText - Tekst på bekræftelsesknappen
 * @param {string} cancelText - Tekst på annulleringsknappen
 * @param {string} confirmButtonType - Type af bekræftelsesknappen ('primary', 'danger', etc.)
 * @param {boolean} isLoading - Om der vises loading state på bekræftelsesknappen
 */
const ConfirmationModal = ({
    isOpen = false,
    onClose,
    onConfirm,
    title = 'Bekræft handling',
    message = 'Er du sikker på at du vil fortsætte?',
    confirmText = 'Bekræft',
    cancelText = 'Annuller',
    confirmButtonType = 'primary',
    isLoading = false,
}) => {
    const handleConfirm = () => {
        if (onConfirm) {
            onConfirm()
        }
    }

    let confirmButtonColor
    if (confirmButtonType === 'danger') {
        confirmButtonColor = 'var(--danger-button-color)'
    } else if (confirmButtonType === 'confirmation') {
        confirmButtonColor = 'var(--confirmation-button-color)'
    } 

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title={title}
            size="small"
            showCloseButton={true}
            closeOnOverlayClick={true}
            closeOnEscape={true}
        >
            <div className="confirmation-modal-content">
                <p className="confirmation-message">{message}</p>
                
                <div className="confirmation-actions">
                    <Button
                        title={cancelText}
                        onClick={onClose}
                        variant="secondary"
                        disabled={isLoading}
                        style={{
                            width: '100%',
                        }}
                    />
                    <Button
                        title={confirmText}
                        onClick={handleConfirm}
                        variant={confirmButtonType}
                        disabled={isLoading}
                        loading={isLoading}
                        style={{
                            width: '100%',
                            backgroundColor: confirmButtonColor
                        }}
                    />
                </div>
            </div>
        </Modal>
    )
}

export default ConfirmationModal
